import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from '../../shared/services/request.service';
import { OrderStatus } from '../orders/enums/order-status.enum';
import { PaymentStatus } from '../orders/enums/payment-status.enum';
import { ReservationReportFilter } from './models/reservation-report.filter';
import { StatisticsFilter } from './models/statistics.filter';
import { TotalOrdersReport, TotalOrdersReportResponse } from './models/total-orders-report';

@Injectable()
export class StatisticsService {
  constructor(private requestService: RequestService) {}

  async getTotalOrdersReport(
    filter: StatisticsFilter,
    page: number,
    size: number
  ): Promise<TotalOrdersReportResponse> {
    console.log(filter);
    let urlRequest: string = this.requestService.buildUrlPathParams(
      {
        groupbyday: filter.grouped,
        startDate: filter.startDate,
        endDate: filter.endDate,
        estabId: filter.establishmentId,
        count: filter.count,
        page: page,
        size: size,
      },
      APP_CONFIG.WEBSERVICE.GET_TOTAL_ORDERS_REPORT
    );
    urlRequest +=
      '&paymentStatus=' +
      PaymentStatus.PAID +
      ',' +
      PaymentStatus.CANCELLED +
      ',' +
      PaymentStatus.REVERSED;

    const filterOrderStatus: Array<OrderStatus> = [
      // OrderStatus.IN_QUEUE['code'],
      // OrderStatus.IN_PRODUCTION['code'],
      // OrderStatus.PARTIAL_DELIVERED['code'],
      // OrderStatus.FINISHED['code'],
      OrderStatus.RATED['code'],
      OrderStatus.DELIVERED['code'],
      OrderStatus.CANCELED_BY_ESTABLISHMENT['code'],
      OrderStatus.CANCELED_BY_CUSTOMER['code'],
    ];

    urlRequest += '&orderStatus=' + filterOrderStatus.join(',');

    console.log(urlRequest);
    const response: TotalOrdersReportResponse = await this.requestService.getData(urlRequest);
    const totalOrders: Array<TotalOrdersReport> = new Array<TotalOrdersReport>();
    if (response && response.ordersReport) {
      response.ordersReport.forEach((total) => {
        totalOrders.push(new TotalOrdersReport(total));
      });
      response.ordersReport = totalOrders;
    }
    return response;
  }

  async getReservationReport(filter: ReservationReportFilter): Promise<any> {
    console.log(filter);
    let urlRequest: string = this.requestService.buildUrlPathParams(
      {
        startDate: filter.startDate,
        endDate: filter.endDate,
        storeId: filter.storeId,
        page: filter.page,
        size: filter.size,
        orderType: filter.orderType || 'desc',
      },
      APP_CONFIG.WEBSERVICE.RESERVATION_REPORT
    );
    if (filter.status && filter.status.length > 0) {
      urlRequest += '&tableReservationStatus=' + filter.status.join(',');
    }
    console.log(urlRequest);
    const response: any = this.requestService.getData(urlRequest);
    const totalOrders: Array<TotalOrdersReport> = new Array<TotalOrdersReport>();
    if (response && response.ordersReport) {
      response.ordersReport.forEach((total) => {
        totalOrders.push(new TotalOrdersReport(total));
      });
      response.ordersReport = totalOrders;
    }
    return response;
  }

  async exportReport(filter: ReservationReportFilter): Promise<any> {
    console.log(filter);
    let urlRequest: string = this.requestService.buildUrlPathParams(
      {
        startDate: filter.startDate,
        endDate: filter.endDate,
        storeId: filter.storeId,
        orderType: filter.orderType || 'desc',
      },
      APP_CONFIG.WEBSERVICE.EXPORT_RESERVATION_REPORT
    );
    if (filter.status && filter.status.length > 0) {
      urlRequest += '&tableReservationStatus=' + filter.status.join(',');
    }
    if (filter.orderBy) {
      urlRequest += '&orderBy=' + filter.orderBy;
    }
    this.requestService.addParamsHeader('Content-Type', 'application/octet-stream');
    const filename: string = `fastget_reservas_${filter.startDate}_${filter.endDate}.csv`;
    return await this.requestService.downloadFile(urlRequest, filename);
  }

  async exportPlaceOrdersReport(placeId: number, startDate: string, endDate: string): Promise<any> {
    let urlRequest: string = this.requestService.buildUrlPathParams(
      { placeId: placeId },
      APP_CONFIG.WEBSERVICE.EXPORT_PLACE_ORDERS_REPORT
    );
    urlRequest += `?${this.requestService.buildUrlParams({
      startDate: startDate,
      endDate: endDate,
      orderType: 'desc',
    })}`;
    this.requestService.addParamsHeader('Content-Type', 'application/octet-stream');
    const filename: string = `fastget_pedidos_lojas_${startDate}_${endDate}.csv`;
    return await this.requestService.downloadFile(urlRequest, filename);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/statistics/statistics.service.ts